import { AnalysisKeywordsResultGroup, ChatBotHistorySearch, usePostApiAnalysisKeywordsChatBot } from "@/API";
import { Button, Center, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { PropsWithChildren, useState } from "react";
import { PieChart } from '@mantine/charts';
import { get_random_hue_color_from_string } from "@/Helpers/RandomColor";

export function ChatBotAnalysisKeywordsButton(props: { search: ChatBotHistorySearch }) {
    const [opened, { open, close }] = useDisclosure(false);
    const [loading, setLoading] = useState(false)
    const AnalysisKeywords_Mutation = usePostApiAnalysisKeywordsChatBot()
    const [data, setData] = useState<AnalysisKeywordsResultGroup[]>([])
    return <>
        <Button loading={loading} onClick={async () => {
            setLoading(true)
            try {
                var result = await AnalysisKeywords_Mutation.mutateAsync({
                    data: props.search
                })
                setData(result.data)
                open()
            } catch (e) {
                notifications.show({ message: "分析失敗", color: "red" })
            }
            setLoading(false)
        }}>
            分析關鍵字
        </Button>
        <Modal opened={opened} onClose={close} title="" closeOnClickOutside={false}>
            <Center h="100%" m={20}>
                <PieChart size={200} withLabelsLine labelsPosition="outside" labelsType="value" withTooltip withLabels data={data.map(x => {
                    var name = x.center?.keywords?.join(", ") ?? ""
                    return {
                        name: name,
                        value: x.results?.length ?? 0,
                        color: get_random_hue_color_from_string(50, 60, name)
                    }
                })} />
            </Center>
        </Modal>
    </>
}